import { Injectable, OnDestroy } from '@angular/core';
import { interval, Observable, Subject, Subscription } from 'rxjs';
import { RefreshDataState } from '../domain/refresh-data-state';

@Injectable({
   providedIn: 'root'
})
export class DataStoreService implements OnDestroy {
   public refreshTaskDataSubject: Subject<RefreshDataState> = new Subject();
   private intervalEveryMinuteSubscription: Subscription = new Subscription();
   private intervalEveryFiveMinuteSubscription: Subscription = new Subscription();
   private minuteTimer: Observable<number> = new Observable<number>();
   private fiveMinuteTimer: Observable<number> = new Observable<number>();

   constructor() {
      this.minuteTimer = interval(60000);
      this.fiveMinuteTimer = interval(5 * 60 * 1000);
   }

   ngOnDestroy(): void {
      this.intervalEveryMinuteSubscription.unsubscribe();
      this.intervalEveryFiveMinuteSubscription.unsubscribe();
   }

   public refreshTaskData(state: RefreshDataState) {
      this.refreshTaskDataSubject.next(state);
   }

   public RunTaskEveryMinute(fn: () => void) {
      this.intervalEveryMinuteSubscription.add(this.minuteTimer.subscribe(fn));
   }

   public RunTaskEveryEveryFiveMinutes(fn: () => void) {
      this.intervalEveryMinuteSubscription.add(this.fiveMinuteTimer.subscribe(fn));
   }
}
